module.exports = __webpack_public_path__ + "static/media/pic1.171f78f6.jpg";